// extracted by mini-css-extract-plugin
export default {"menuList":"MailboxContentTableQuickFilters_menuList__6Bdpi","menuItem":"MailboxContentTableQuickFilters_menuItem__20iHU"};